import Route from '@ember/routing/route';
import { useQuery } from 'glimmer-apollo';
import { REVIEWS_POST_QUERY } from 'embroil/gql/queries/reviews-post';
import { service } from '@ember/service';

export default class ReviewsPost extends Route {
  @service head;

  async model({ slug }) {
    try {
      this.data = useQuery(this, () => [
        REVIEWS_POST_QUERY,
        { variables: { slug } },
      ]);

      await this.data.promise;
      // New GraphQL API returns direct object, not collection/items structure
      return this.data.data.article;
    } catch (error) {
      console.error('Error loading review post:', error);
      // Redirect to 404 or return null to show error page
      this.replaceWith('404');
      return null;
    }
  }

  afterModel(model) {
    if (model) {
      this.head.updateMeta({
        title: model.title,
        description: model.shortDescription,
        ogTitle: model.title,
        ogDescription: model.shortDescription,
        ogImage: model.coverImage.url,
        ogType: 'article',
        canonical: `https://1vX.gg/reviews/${model.slug}`
      });
    }
  }
}
